import {Component, OnInit} from '@angular/core';
import { MdDialogRef } from '@angular/material';

@Component({
  selector: 'app-dropdown-dialog',
  templateUrl: './dropdown-dialog.component.html',
  styleUrls: ['./dropdown-dialog.component.scss']
})
export class DropdownDialogComponent implements OnInit {

  constructor(public dialogRef: MdDialogRef<DropdownDialogComponent>) { }

  public title = '';
  public valueSelected;
  public options = [];

  private unSelectedError = false;

  allowZeroError = false;

  ngOnInit() {
    this.checkErrors();
  }

  onSubmit() {
    if (!this.checkErrors()) {
      this.dialogRef.close(this.valueSelected);
    }
  }

  checkErrors() {
    if (!this.valueSelected) {
      this.unSelectedError = true;
    }

    return this.unSelectedError;
  }

  getInputHasErrors() {
    return this.unSelectedError;
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/dialog/dropdown-dialog/dropdown-dialog.component.ts